export const API_PATH = 'https://api.vinesolucoes.com.br/vine';